module.exports = __webpack_public_path__ + "img/06a_Share_Persona.cd054b9a.jpg";